export const SP_QUERY_STRINGS = {
  PAGE: 'sp_page',
  CATEGORY: 'sp_category',
  LINE: 'sp_line',
  SERIES: 'sp_series',
  MODEL: 'sp_model',
};
